/**FIXME -
 * This hook will get the listing information on the listings that the user has placed a bid on.
 * There are two options for getting these bids.
 * A. Get all active listings --> pass in the lotId to getBids --> connect active user to user in the list to see if there is a match
 * It will require multiple for loops which isnt ideal for a scalable application.
 *
 * B. Add an array to the DB listing structure that is bids. When a user places a bid on a listing their address is saved to the array.
 * Loop through the DB active listings bids array and see if there is a match between the active user and the address in the array.
 * This will require one for loop.
 *
 * C. When the user makes a bid save the listing ID to the user in the DB in an array.
 * 
 * D. FIXME - CHOSEN ******
 *    The user makes an offer (rental or bid) and that gets added to the web3 listing and is updated in the "offers" array in the DB
 *    When retreiving the bids for that user --> get all of the listings --> filter through the array and return a match for the loggedin user
 *    save the listings to state and have the hook return the data
 * Then use the DB filter function to retreive the listings with the match
 *
 * Need an easy way to find out what listings the user has bid on.
 * ANCHOR - Possible functions of use
 * 1. AllActiveListings
 * 2. getPropertylistings
 * 3. BidsofLot
 */

import React, { useState, useEffect } from "react";
//import Moralis from "moralis";
import { createClient } from "@supabase/supabase-js";

//Provider
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";

// ABI


function useGetUserBids() {
  let _ = require("lodash");
  const [userBids, setUserBids] = useState();
  const { walletAddress } = useAcreDapp();

  const supabase = createClient(
    `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
    `${process.env.REACT_APP_SUPABASE_API_KEY}`
  );

  useEffect(() => {
  
    const getUserBids = async () => {
      try {
        let { data, error, status } = await supabase
          .from("listings")
          .select()
          .eq("listing_public", true);

        if (error && status !== 406) {
          throw error;
        }
        if (data) {
          const filteredListings = _.filter(data, function(listings) {return listings.user_address === walletAddress});
          setUserBids(filteredListings);
        }
        if (status) {
          console.log("Database status: ", status);
        }
      } catch (error) {
        console.table(error);
      }
    };

    getUserBids();
  }, []);

  return userBids;
}
export default useGetUserBids;
